import { Gem } from "lucide-react";

export default function Logo({ size = 22, dark = false, className = "" }) {
  return (
    <div data-testid="enbissy-logo" className={`inline-flex items-center gap-2 ${className}`}>
      <Gem size={size} strokeWidth={1.6} className={dark ? "text-white" : "text-black"} />
      <span
        className="font-display font-extrabold tracking-[0.18em]"
        style={{ fontSize: size * 0.85, color: dark ? "#fff" : "#0a0a0a" }}
      >
        ENBISSY
      </span>
    </div>
  );
}
